<!-- help-dock.component.html -->
<div class="help-dock"
     [class.open]="open"
     [style.--mini-width]="miniWidth"
     [style.--mini-min-width]="miniMinWidth"
     [style.--mini-max-width]="miniMaxWidth">

  <button class="tab"
          type="button"
          pRipple
          [pTooltip]="'HelpCenter.Tooltip.Help' | translate"
          tooltipPosition="left"
          aria-label="Open help"
          (click)="togglePin()">
    <i class="pi pi-lightbulb"></i>
  </button>

  <div class="panel">
    <div class="panel-header">
      <div class="title"
           [pTooltip]="headerTitle"
           tooltipPosition="bottom">
        {{ headerTitle }}
      </div>
      <div class="actions">
        <button pButton
                class="p-button-text p-button-sm"
                icon="pi pi-window-maximize"
                (click)="openDialog()"
                [pTooltip]="'HelpCenter.Button.Expand' | translate"
                tooltipPosition="bottom">
        </button>
        <button pButton
                class="p-button-text p-button-sm"
                icon="pi pi-external-link"
                (click)="navigateToSetting()"
                [pTooltip]="'HelpCenter.Button.NavigateToSetting' | translate"
                tooltipPosition="bottom">
        </button>
        <button pButton
                class="p-button-text p-button-sm"
                [icon]="pinned ? 'pi pi-times' : 'pi pi-thumbtack'"
                (click)="togglePin()"
                [pTooltip]="pinned ? ('HelpCenter.Button.Unpin' | translate) : ('HelpCenter.Button.Pin' | translate)"
                tooltipPosition="bottom">
        </button>
      </div>
    </div>

    <p-tabView
      [(activeIndex)]="activeTabIndex"
      (activeIndexChange)="onTabChange($event)">

      <!-- Tab 1: 使用者說明 -->
      <p-tabPanel [header]="'HelpCenter.View.TabHeader' | translate">
        <div class="grid">
          <div class="col-12"
               [class.col-9]="showMiniToc"
               [class.col-12]="!showMiniToc">
            <div #userBody class="body" [innerHTML]="releasedUserHtml"></div>
          </div>

          <div class="col-3" *ngIf="showMiniToc">
            <div class="toc-title">TOC</div>
            <ul class="toc">
              <li *ngFor="let t of tocUser"
                  (click)="scrollTo(t.id)"
                  [class.active]="activeId === t.id">
                <span [style.marginLeft.px]="(t.level - 1) * 10">{{ t.text }}</span>
              </li>
            </ul>
          </div>
        </div>
      </p-tabPanel>

      <!-- Tab 2: IT 說明 -->
      <p-tabPanel [header]="'HelpCenter.View.TabITHeader' | translate">
        <div class="grid">
          <div class="col-12"
               [class.col-9]="showMiniToc"
               [class.col-12]="!showMiniToc">
            <div #itBody class="body" [innerHTML]="releasedItHtml"></div>
          </div>

          <div class="col-3" *ngIf="showMiniToc">
            <div class="toc-title">TOC</div>
            <ul class="toc">
              <li *ngFor="let t of tocIT"
                  (click)="scrollTo(t.id)"
                  [class.active]="activeId === t.id">
                <span [style.marginLeft.px]="(t.level - 1) * 10">{{ t.text }}</span>
              </li>
            </ul>
          </div>
        </div>
      </p-tabPanel>

      <!-- Tab 3: 附件下載 -->
      <p-tabPanel [header]="'HelpCenter.View.TabFileHeader' | translate">
        <div class="attachments-container">
          <!-- 無附件時顯示 -->
          <div *ngIf="docs.length === 0" class="no-attachments">
            <i class="pi pi-inbox"></i>
            <p>{{ 'HelpCenter.Message.NoAttachments' | translate }}</p>
          </div>

          <!-- 附件列表 -->
          <div *ngIf="docs.length > 0" class="attachments-list">
            <div class="attachment-item"
                 *ngFor="let doc of docs"
                 (click)="downloadDoc(doc)"
                 [pTooltip]="doc.name"
                 tooltipPosition="top">
              <div class="attachment-icon">
                <i class="pi pi-file"></i>
              </div>
              <div class="attachment-info">
                <div class="attachment-name">{{ doc.name }}</div>
              </div>
              <div class="attachment-action">
                <i class="pi pi-download"></i>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>

  <div *ngIf="loadingCnt > 0" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>
